import { Navigate } from 'react-router';
import type { FC } from 'react';
import { useUserProfile } from 'src/contexts/UserProfileContext';
import useHasPermissions from 'src/hooks/useHasPermission';
import { getSecurityLandingPath } from './securityNav';
import { toSecurityChildPath } from './securityRoutes';

const SecurityIndexRedirect: FC = () => {
  const checkPermissions = useHasPermissions();
  const { userData } = useUserProfile();
  const isReseller = userData?.organization?.organizationTypeName === 'Reseller';
  const landingPath = getSecurityLandingPath(checkPermissions, isReseller);

  if (!landingPath) return null;

  return <Navigate to={toSecurityChildPath(landingPath)} replace />;
};

export default SecurityIndexRedirect;
